import { KeyTextField } from '@prismicio/client';

import styles from './statisticsDescriptions.module.scss';

interface StatisticsDescriptionsProps {
  activeItem: number;
  items: KeyTextField[];
}
export const StatisticsDescriptions = ({
  items,
  activeItem,
}: StatisticsDescriptionsProps) => {
  return (
    <div className={styles.wrapper}>
      <ul className={styles.list}>
        {items.map((item, index) => (
          <li
            key={item}
            className={`${styles.item} ${activeItem === index ? styles.visible : styles.hidden}`}
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};
